module.exports = __webpack_public_path__ + "img/szemelyes.acc4eb0e.png";